<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
        <div class="form js-form">
          <submenu />

          <TextBox
            label="Label_Name"
            v-model="model.name"
            :validate="$v.model"
            v-on:input="$v.model.$touch"
            modelPath="name"
            acc="name"
          />

          <TextBox
            label="Label_Amount"
            v-model="model.amount"
            :validate="$v.model"
            v-on:input="$v.model.$touch"
            modelPath="amount"
            type="number"
            :min="0"
            :max="5000"
            step="0.01"
            acc="amount"
          />

          <Btn :isLoading="loading" v-on:click="save" label="Label_SaveButton" />
          <Btn v-on:click="$router.push({name: 'taxes'})" label="Label_CancelButton" :withBorder="true" />
        </div>
      </div>
    </article>
  </article>
</template>

<script>
import { TextBox, Btn } from 'components/layout/forms'
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import Submenu from 'components/views/membership/Submenu'
import notifications from 'mixins/notifications'
import { required } from 'vuelidate/lib/validators'
import { Validation } from 'components/helpers'

export default {
  name: 'tax',
  components: { Submenu, TextBox, Btn, Validation },
  mixins: [notifications],
  data() {
    return {
      L: L,
      loading: false,
      title: L.localize('Membership_Breadcrumb_Index'),
      model: {
        id: '',
        name: '',
        amount: 0
      }
    }
  },
  beforeCreate() {
    if (this.$route.params.id) {
      this.$store.dispatch('getTax', this.$route.params.id).then(() => {
        this.mapFromState()
      })
    }
  },
  beforeDestroy() {
    this.$store.dispatch('getTax', null)
  },
  validations: {
    model: {
      name: { required },
      amount: { required }
    }
  },
  computed: {
    ...mapGetters({
      tax: 'activeTax'
    })
  },
  methods: {
    mapFromState() {
      _.assign(this.model, this.tax)
      if (this.tax) {
        this.title = this.tax.name
      }
    },
    save() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return;
      }
      this.loading = true
      let tax = this.model
      this.$store.dispatch('createOrUpdateTax', tax).then(
        // resolve
        () => {
          this.loading = false
          if (tax.id === '') {
            this.$router.push({name: 'tax', params: { id: this.tax.id }})
            this.showNotification({
              title: L.localize('Label_SuccessCreation'),
              message: L.localize('Label_Success')
            })
          } else {
            this.mapFromState()
            this.showNotification({
              title: L.localize('Label_SuccessEdit'),
              message: L.localize('Label_Success')
            })
          }
        },
        // reject
        () => {
          this.loading = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// Tax.vue?b9f5ed0a